export const COMPLETED_SUPPLIER_STATUSES_FOR_OVERDUE = new Set(["billed", "closed"]);

export const normalizePurchasingDashboardSupplierStatus = (value) =>
  String(value || "").trim().toLowerCase();

export const isSemanticPurchasingDashboardOverduePreset = ({
  activeTab = "all",
  criteria = {},
} = {}) => {
  const hasExplicitRange =
    String(criteria?.dateFrom || "").trim() || String(criteria?.dateTo || "").trim();
  return !hasExplicitRange && (
    String(activeTab || "").trim().toLowerCase() === "overdue" ||
    String(criteria?.dateQuick || "").trim().toLowerCase() === "overdue"
  );
};

export const resolvePurchasingDashboardRowDate = (row = {}, dateType = "nextActionDate") => {
  if (dateType === "inHandsDate") {
    return row.inHandsDate || row.inhandsDate || row.naDate || null;
  }
  if (dateType === "poCreated") {
    return row.createdAt || row.poCreated || null;
  }
  return row.nextActionDate || row.naDate || null;
};

export const matchesPurchasingDashboardOverdueRow = ({
  row = {},
  criteria = {},
  activeTab = "all",
  now = new Date(),
} = {}) => {
  if (!isSemanticPurchasingDashboardOverduePreset({ activeTab, criteria })) return true;
  const dateType = String(criteria?.dateType || "nextActionDate").trim() || "nextActionDate";
  const selectedDate = resolvePurchasingDashboardRowDate(row, dateType);
  if (!selectedDate) return false;
  const parsed = new Date(selectedDate);
  if (Number.isNaN(parsed.getTime())) return false;
  if (parsed >= now) return false;
  return !COMPLETED_SUPPLIER_STATUSES_FOR_OVERDUE.has(
    normalizePurchasingDashboardSupplierStatus(row?.supplierStatus || row?.supplierStage)
  );
};
